import $ from "jquery";
import * as _ from "underscore";

import * as accentInputPanel from "accentInputPanel";
import compositeViewMixin from "compositeViewMixin";
import * as currentDate from "currentDate";
import * as deviceDetect from "deviceDetect";
import * as editCardDialog from "editCardDialog";
import * as keyboardShortcuts from "keyboardShortcuts";
import loadHandwritingFont from "loadHandwritingFont";
import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import FlashcardSessionModel from "models/FlashcardSessionModel";
import UserWordModel from "models/UserWordModel";
import models from "models/models";
import * as mustcache from "mustcache";
import * as practiceUtils from "practiceUtils";
import readlangClient from "readlangClient";
import * as dateUtils from "shared/dateUtils";
import * as languageMap from "shared/languageMap";
import * as spacedRepetition from "shared/spacedRepetition";
import spannify from "shared/spannify";
import * as utils from "shared/utils";
import * as soundEffect from "soundEffect";
import * as spanTranslator from "spanTranslator";
import * as splitTest from "splitTest";
import * as textToSpeech from "textToSpeech";
import * as translate from "translate";
import * as transliterations from "transliterations";
import ToggleSpeakingModeView from "views/ToggleSpeakingModeView";
import * as walkthrough from "walkthrough";
import XRegExp from "xregexp";

const pageName = "flashcardsPage";
export const name = pageName;

let suppressUpdates = false;
let readyToTest;
let contextElement;
let contextContainer;
let currentContextIndex = null;
let typingMode;
let element;
let options;
let wordCardInputRows;

let guessForeignWord;

let buttonsElement;
let feedbackElement;
let wordCard;
let wordCardText;
let wordCardInput;
let wordCardInputToolbar;
let translationCard;
let translationText;
let hintElement;
let editElement;
let categoryElement;
let wordCardAudio;
let imageElement;
let imageHintElement;
let nextCardButton;
let deleteButton;
let feedbackTick;
let submitAnswer;
let addAlternativeWord;
let typingModeLabel;
let typingModeCheckbox;
let cardCount;
let exitTestButton;
let contextLink;
let originalWordVisible;
let translationVisible;
let showSpeakingModeToggle;
let subviewManager;
let showNoteButton;
let noteElement;

const shrinkToFit = (innerElement, containerElement) => {
  if (innerElement.width() > containerElement.width()) {
    innerElement.addClass("shrinkText1");
  }
  if (innerElement.width() > containerElement.width()) {
    innerElement.removeClass("shrinkText1").addClass("shrinkText2");
  }
  if (innerElement.width() > containerElement.width()) {
    innerElement.removeClass("shrinkText2").addClass("shrinkText3");
  }
};

const regexpEscape = (input) => input.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");

const setContext = (context) => {
  contextElement.html(context.text);
  spanTranslator.setup({
    element: contextContainer,
    sourceLang: models.flashcardSession.get("currentWord").get("language"),
    models: models,
    translator: translate.getTranslator({
      models: models,
      notify: function (notifyOptions) {
        console.log(
          "notify: ",
          notifyOptions.message || notifyOptions.htmlMessage
        );
      },
      dismissNotification: function () {
        console.log("dismiss notification");
      },
    }),
    userWordCreator: function (wordDefinition) {
      return new UserWordModel(wordDefinition);
    },
    forceReaderTranslations: true,
  });

  // book link
  if (context.bookID && context.bookID.title) {
    $("#contextLink")
      .text(utils.elide(context.bookID.title, 80))
      .attr("href", "/library/" + context.bookID._id + "/from/0")
      .show();
  } else if (context.URL) {
    $("#contextLink")
      .text("Original article - " + context.URL)
      .attr("href", context.URL)
      .show();
  } else {
    $("#contextLink").text("").attr("href", "").show();
  }
};

let initialized = false;

export const render = async (
  _containerElement,
  renderedCallback,
  appRouter,
  _options
) => {
  element = _containerElement;
  options = _options || {};

  if (
    ["new", "blitz"].includes(await practiceUtils.practiceType(models.user))
  ) {
    let newUrl = "/practice";

    if (options.chosenBookID) {
      newUrl = `/practice/book/${options.chosenBookID}`;
    } else if (options.userWordIDs) {
      newUrl = `/practice/words/${options.userWordIDs}`;
    }

    appRouter.navigate(newUrl, { replace: true, trigger: true });
    return;
  }

  appRouter.navigate("/flashcards", { replace: true });

  if (!initialized) {
    models.userWords.on("groupsReCreated", () => {
      if ($("body").attr("id") === pageName && !suppressUpdates) {
        render(element, renderedCallback, appRouter, options);
      }
    });
    models.user.on("change:currentLearningLanguage", () => {
      if (
        $("body").attr("id") === pageName &&
        (!options.language ||
          options.language !== models.user.get("currentLearningLanguage"))
      ) {
        models.flashcardSession.reset();
        appRouter.navigate("/learn", { trigger: true });
      }
    });
    models.remoteUserWords.on("add change remove", () => {
      if ($("body").attr("id") !== pageName) {
        models.flashcardSession.set("currentWord", null);
        models.flashcardSession.reset();
      }
    });
    if (!models.flashcardSession) {
      models.flashcardSession = new FlashcardSessionModel({
        models: models,
      });
    }
    initialized = true;
  }

  const numberOfCards = practiceUtils.cardsPerSession(models.user);

  // for translating words in the context
  $("body").attr("data-clickMode", "translate");
  if (models.user.get("readerTranslationStyle") !== "replace") {
    if (models.user.get("readerTranslationStyle") === "glossNew") {
      $("body").addClass("glossStyleNew");
    } else {
      $("body").addClass("glossStyle");
    }
    if (languageMap.map[models.user.get("firstLanguage")].alphabet) {
      $("body").removeClass("basicLatinFirstLanguage");
    } else {
      $("body").addClass("basicLatinFirstLanguage");
    }
    loadHandwritingFont();
  }

  // Add interface for templateData
  interface FlashcardsTemplateData {
    user: any;
    wordCardAudio: boolean;
    typingMode?: boolean;
  }

  const renderFlashcards = () => {
    const templateData: FlashcardsTemplateData = {
      user: models.user.toJSON(),
      wordCardAudio: textToSpeech.languageSupported(
        models.user.get("currentLearningLanguage")
      ),
    };
    if (models.user.get("typingMode")) {
      templateData.typingMode = true;
    }

    element.html(mustcache.render("flashcardsPage", templateData));

    renderedCallback(options);

    if (subviewManager) {
      subviewManager.removeSubviews();
    }
    subviewManager = _.extend({}, compositeViewMixin);
    if (showSpeakingModeToggle) {
      subviewManager.setSubviews({
        toggleSpeakingModeView: new ToggleSpeakingModeView({
          model: models.user,
          el: "#toggleSpeakingModeButton",
        }),
      });
    }

    buttonsElement = element.find("#buttons");
    feedbackElement = element.find("#feedback");
    wordCard = element.find("#word");
    wordCardText = element.find("#wordCardText");
    wordCardInput = element.find("#wordCardInput");
    wordCardInputToolbar = element.find("#wordCardInputToolbar");
    translationCard = element.find("#translation");
    translationText = element.find("#translationText");
    hintElement = element.find("#newCardHint");
    editElement = element.find("#editCard");
    categoryElement = translationCard.find(".cornerRibbon");
    wordCardAudio = element.find("#wordCardAudio");
    imageElement = element.find("#image");
    imageHintElement = element.find("#imageHint");
    nextCardButton = element.find("#nextCardButton");
    deleteButton = element.find("#delete");
    feedbackTick = element.find("#feedbackTick");
    submitAnswer = element.find("#submitAnswer");
    addAlternativeWord = element.find("#addAlternativeWord");
    typingModeLabel = element.find("#typingMode");
    typingModeCheckbox = typingModeLabel.find("input");
    cardCount = element.find("#cardCount");
    exitTestButton = element.find("#exitTest");
    contextLink = element.find("#contextLink");
    showNoteButton = element.find("#showNote");
    noteElement = element.find("#note");

    showNoteButton.hide();
    noteElement.hide();
    wordCardInputRows = 1;
    wordCardInput.attr("rows", wordCardInputRows);
    hintElement.hide();
    editElement.hide();
    imageElement.removeAttr("src").hide();
    imageHintElement.hide();
    nextCardButton.hide();
    feedbackTick.hide();
    addAlternativeWord.hide();
    contextLink.html("&nbsp;"); // Hide it while maintaining the height
    submitAnswer.hide();

    originalWordVisible = false;
    translationVisible = false;

    wordCardInputRows = 1;
    wordCardInput.on("keyup", () => {
      if (wordCardInput.scrollTop() > 0) {
        wordCardInputRows++;
        wordCardInput.attr("rows", wordCardInputRows);
      }
      submitAnswer.show();
    });

    typingModeCheckbox.change(() => {
      models.user.save(
        { typingMode: typingModeCheckbox.is(":checked") },
        { patch: true }
      );

      setTimeout(() => {
        if (showSessionCompleteIfAppropriate()) {
          return;
        }
        displayNext();
      }, 0);
    });

    typingModeLabel
      .click((event) => {
        event.stopPropagation();
      })
      .hover(
        () => {
          wordCard.addClass("disableHover");
        },
        () => {
          wordCard.removeClass("disableHover");
        }
      );

    accentInputPanel.create(
      wordCardInputToolbar,
      wordCardInput,
      models.user.get("currentLearningLanguage")
    );

    contextContainer = element.find("#contextContainer");
    contextElement = element.find("#context");

    wordCardAudio.click(() => {
      wordCardAudio
        .removeClass("icon-volume-down")
        .addClass("icon-spinner icon-spin");

      textToSpeech.play(
        models.user.get("currentLearningLanguage"),
        models.flashcardSession.get("currentWord").get("word"),
        () => {
          wordCardAudio
            .removeClass("icon-spinner icon-spin")
            .addClass("icon-volume-down");
        }
      );
    });

    if (showSpeakingModeToggle) {
      subviewManager.subviews.toggleSpeakingModeView.on("speak", () => {
        if (originalWordVisible) {
          textToSpeech.play(
            models.user.get("currentLearningLanguage"),
            models.flashcardSession.get("currentWord").get("word"),
            () => {
              wordCardAudio
                .removeClass("icon-spinner icon-spin")
                .addClass("icon-volume-down");
            }
          );
        }
      });
    }

    const enterOrSpaceHandler = () => {
      if (!typingMode || !guessForeignWord) {
        if (translationCard.hasClass("clickable")) {
          translationCard.click();
        } else if (wordCard.hasClass("clickable")) {
          wordCard.click();
        }
      }
    };

    const ENTER_KEY = 13;
    const SPACE_KEY = 32;
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      ENTER_KEY,
      enterOrSpaceHandler
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      SPACE_KEY,
      enterOrSpaceHandler
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "1".charCodeAt(0),
      () => {
        if (buttonsElement.is(":visible")) {
          buttonsElement.find('.recall[data-score="0"]').click();
        }
      }
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "2".charCodeAt(0),
      () => {
        if (buttonsElement.is(":visible")) {
          buttonsElement.find('.recall[data-score="2"]').click();
        }
      }
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "3".charCodeAt(0),
      () => {
        if (buttonsElement.is(":visible")) {
          buttonsElement.find('.recall[data-score="4"]').click();
        }
      }
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "4".charCodeAt(0),
      () => {
        if (buttonsElement.is(":visible")) {
          buttonsElement.find('.recall[data-score="5"]').click();
        }
      }
    );
    const clickDeleteButtonIfAppropriate = () => {
      if (models.flashcardSession.has("currentWord")) {
        deleteButton.click();
      }
    };
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "d".charCodeAt(0),
      () => {
        clickDeleteButtonIfAppropriate();
      }
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      8 /* backspace */,
      () => {
        clickDeleteButtonIfAppropriate();
      }
    );
    keyboardShortcuts.registerHandler("flashcardsPage", 37, () => {
      cycleContext(false);
    });
    keyboardShortcuts.registerHandler("flashcardsPage", 39, () => {
      cycleContext(true);
    });
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "E".charCodeAt(0),
      () => {
        if ($("#editCardDialog").length > 0) {
          modalDialog.cancel();
        } else {
          // Call this to reveal the answer if it needs revealing
          if (typingMode && guessForeignWord) {
            judgeAnswer();
          } else {
            enterOrSpaceHandler();
          }

          // Trigger a click on the edit button
          element.find("#editCard").click();
        }
      },
      true,
      true,
      deviceDetect.info().mac ? "meta" : "ctrl"
    );
    keyboardShortcuts.registerHandler(
      "flashcardsPage",
      "P".charCodeAt(0),
      (event) => {
        if (!originalWordVisible) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        textToSpeech.play(
          models.user.get("currentLearningLanguage"),
          models.flashcardSession.get("currentWord").get("word")
        );
      },
      true,
      true,
      deviceDetect.info().mac ? "meta" : "ctrl"
    );

    if (
      languageMap.map[models.user.get("currentLearningLanguage")].direction ===
      "RTL"
    ) {
      contextElement.css("direction", "RTL");
      wordCard.css("direction", "RTL");
    }

    imageHintElement.click((event) => {
      event.preventDefault();
      event.stopPropagation();
      imageElement.fadeIn();
      imageHintElement.hide();
    });

    nextCardButton.click((event) => {
      // Not sure why this timeout is here. It was 300ms. I was worried about removing it so I've
      // reduced it to 10ms so that it appears instant to the user. Consider removing completely.
      setTimeout(() => {
        if (showSessionCompleteIfAppropriate()) {
          return;
        }
        displayNext();
      }, 10);
      event.stopPropagation();
      event.preventDefault();
    });

    contextContainer.find("#nextContext").click((event) => {
      event.stopPropagation();
      event.preventDefault();

      cycleContext(true);
    });

    translationCard.click(function () {
      const $this = $(this);

      if ($this.hasClass("clickable")) {
        // reveal answer
        translationVisible = true;
        translationText.text(
          [
            models.flashcardSession.get("currentWord").get("translation"),
            ...models.flashcardSession
              .get("currentWord")
              .get("alternativeTranslations"),
          ].join(" / ")
        );
        shrinkToFit(translationText, translationCard);
        $this.removeClass("clickable");

        if (imageElement.attr("src")) {
          imageElement.show();
        }
        imageHintElement.hide();

        showRecallButtons();
      }
    });
    wordCard.click(function () {
      const $this = $(this);

      if ($this.hasClass("clickable")) {
        revealWord();
        $this.removeClass("clickable");

        showRecallButtons();
      }
    });

    element.find("#editCard").click(() => {
      editCardDialog.show(models.flashcardSession.get("currentWord"), {
        title: "Edit Card",
        savedCallback: () => {
          // Update UI with new word info
          const currentWord = models.flashcardSession.get("currentWord");
          wordCardText.text(currentWord.get("word"));
          translationText.text(
            [
              currentWord.get("translation"),
              ...currentWord.get("alternativeTranslations"),
            ].join(" / ")
          );
          // XXX Doesn't update the context
        },
        doneCallback: () => {
          modalDialog.cancel();
        },
      });
    });

    exitTestButton.click(() => {
      splitTest.trackEvent("quitFlashcards");
      models.flashcardSession.reset();
      appRouter.navigate("/learn", { trigger: true });
    });

    addAlternativeWord.click(() => {
      const answer = wordCardInput.val().trim();

      if (
        confirm(
          'Do you want to accept "' +
            answer +
            '" as a valid answer?\n\n' +
            "Please be absolutely sure that it fits correctly in the sentence."
        )
      ) {
        const alternativeWords =
          models.flashcardSession.get("currentWord").get("alternativeWords") ||
          [];

        alternativeWords.push(answer);

        models.flashcardSession.get("currentWord").save(
          {
            alternativeWords: alternativeWords,
          },
          {
            success: function () {
              judgeAnswer();
              addAlternativeWord.hide();
            },
            patch: true,
          }
        );
      }
    });

    element.find("#buttons button").click(reportRecallEase);

    deleteButton.click(() => {
      models.flashcardSession.deleteCurrentWord();
      if (showSessionCompleteIfAppropriate()) {
        return;
      }
      displayNext();
    });

    const judgeAnswer = () => {
      editElement.show();
      const answer = utils
        .normalizeString(wordCardInput.val().toLowerCase())
        .trim();
      const expected = utils
        .normalizeString(
          models.flashcardSession.get("currentWord").get("word").toLowerCase()
        )
        .trim();
      let editDistance = utils.levenshteinDistance(answer, expected);

      const alternativeWords =
        models.flashcardSession.get("currentWord").get("alternativeWords") ||
        [];
      _.each(alternativeWords, (altWord) => {
        editDistance = Math.min(
          editDistance,
          utils.levenshteinDistance(
            answer,
            utils.normalizeString(altWord.toLowerCase())
          )
        );
      });

      if (editDistance === 0) {
        reportRecallEase2(5);
      } else if (editDistance / expected.length < 0.2) {
        reportRecallEase2(4);
      } else {
        reportRecallEase2(2);
      }

      nextCardButton.show().focus();
      deleteButton.show();
    };

    wordCardInput.keydown((event) => {
      if (event.which === 13) {
        event.stopPropagation();
        event.preventDefault();

        judgeAnswer();
      }
    });
    submitAnswer.click(judgeAnswer);
  };

  const startTest = (number, selectedBook) => async () => {
    if (
      models.user.speakingModeEnabled(
        models.user.get("currentLearningLanguage")
      )
    ) {
      showSpeakingModeToggle = true;
    } else {
      showSpeakingModeToggle = false;
    }

    if (selectedBook === "all") {
      splitTest.trackEventWithProperties("startFlashcards", {
        numberOfCards: Math.min(number, readyToTest.length),
        from: "all",
      });
    } else {
      readyToTest = await models.userWords.getBookWordsToTest([selectedBook]);

      splitTest.trackEventWithProperties("startFlashcards", {
        numberOfCards: Math.min(number, readyToTest.length),
        from: "specificText",
      });
    }

    if (readyToTest.length === 0) {
      // Boot user back to learn page if there are no words to test
      appRouter.navigate("/learn", { trigger: true });
      return;
    }

    models.flashcardSession.start(
      readyToTest,
      number,
      models.user.getFlashcardMode() === "mixed"
    );

    displayNext();
  };

  const revealWord = () => {
    originalWordVisible = true;

    let html = models.flashcardSession.get("currentWord").get("word");

    const alternativeWords = models.flashcardSession
      .get("currentWord")
      .get("alternativeWords");

    if (alternativeWords && alternativeWords.length > 0) {
      html += "<br/><small><small>or</small> ";
      html += alternativeWords.join(", ");
      html += "</small>";
    }

    typingModeLabel.hide();
    submitAnswer.hide();

    wordCardText.html(html).show();
    shrinkToFit(wordCardText, wordCard);

    fetchTransliterationIfAppropriate();

    wordCardAudio.show();

    if (
      models.user.speakingModeEnabled(
        models.user.get("currentLearningLanguage")
      )
    ) {
      textToSpeech.play(
        models.user.get("currentLearningLanguage"),
        models.flashcardSession.get("currentWord").get("word"),
        () => {}
      );
    }
  };

  const fetchTransliterationIfAppropriate = async () => {
    if (
      !(await transliterations.show(models.user.get("currentLearningLanguage")))
    ) {
      return;
    }

    const word = models.flashcardSession.get("currentWord");

    if (!word) {
      return;
    }

    const language = word.get("language");

    if (!languageMap.map[language].transliterations) {
      return;
    }

    const transliteration = (
      await readlangClient.request(
        "GET",
        "/api/smartDictionary/transliteration",
        {
          language,
          type: languageMap.map[language].transliterations?.[0],
          text: word.get("word"),
        },
        undefined,
        undefined,
        { dataType: "text" }
      )
    ).data;

    // Check that we're still on the same word
    if (word._id !== models.flashcardSession.get("currentWord")._id) {
      console.log("we've moved on.");
      return;
    }

    const html = wordCardText.html();
    wordCardText.html(
      `<div class="transliteration">${transliteration}</div>${html}`
    );
    shrinkToFit(wordCardText, wordCard);
  };

  const updateContexts = () => {
    const currentWord = models.flashcardSession.get("currentWord");
    if (!currentWord) {
      return;
    }

    if (currentWord.get("contexts") && currentWord.get("contexts").length > 1) {
      contextContainer.addClass("multipleContexts");

      if (options.chosenBookID) {
        const contexts = [...currentWord.get("contexts")];
        // If there's a context with a bookID that matches chosenBookID}, use that
        const index = _.findIndex(contexts, (context) => {
          return context.bookID?._id === options.chosenBookID;
        });

        if (index > -1) {
          // Put the chosen context first
          contexts.unshift(contexts.splice(index, 1)[0]);
        }
        currentWord.set("contexts", contexts);
      }
    } else {
      contextContainer.removeClass("multipleContexts");
    }

    const context = currentContext();
    if (context) {
      setContext(context);
      if (guessForeignWord) {
        const strongWord = contextElement.find("strong");
        if (!originalWordVisible) {
          strongWord
            .addClass("hidden")
            .text(
              currentWord
                .get("word")
                .split("")
                .map(() => "_")
                .join("")
            )
            .attr("data-original", currentWord.get("word"));
        }
      }
      contextContainer.show();
    } else {
      contextElement.text("No context");
      contextContainer.show();
    }

    // image
    const imageURL = currentWord.get("imageURL");
    if (imageURL && imageURL.length > 0) {
      imageElement.attr("src", imageURL);
      if (guessForeignWord || (translationVisible && originalWordVisible)) {
        imageElement.fadeIn();
      } else if (!translationVisible) {
        imageHintElement.show();
      }
    } else {
      imageElement.removeAttr("src");
      imageElement.hide();
    }
  };

  const displayNext = async () => {
    typingMode = models.user.get("typingMode");
    currentContextIndex = null;
    models.flashcardSession.set(
      "currentWord",
      models.flashcardSession.has("currentTestDeck") &&
        models.flashcardSession.get("currentTestDeck")[0]
    );

    if (!models.flashcardSession.get("currentWord") || options.userWordIDs) {
      // reset to force updating the XXX words ready count
      models.userWords.resetGroups();

      if (options.userWordIDs) {
        const specificWordIDs = options.userWordIDs.split("|");
        const specificWords = [];
        const needToFetch = [];

        _.each(specificWordIDs, (wordID) => {
          const word = models.remoteUserWords.get(wordID);
          if (word) {
            specificWords.push(word);
          } else {
            needToFetch.push(wordID);
          }
        });

        if (await localAPI.isLocalMode()) {
          readlangClient.login();
          return;
        }

        try {
          if (needToFetch.length > 0) {
            await Promise.all(
              needToFetch.map(async (wordID) => {
                const word = new UserWordModel({ _id: wordID });
                await word.fetch();
                if (!word.has("word")) {
                  throw new Error("no word exists with that id");
                } else {
                  specificWords.push(word);
                }
              })
            );
          }

          if (
            specificWords[0].get("language") !==
            models.user.get("currentLearningLanguage")
          ) {
            await models.user.save(
              {
                currentLearningLanguage: specificWords[0].get("language"),
              },
              { patch: true }
            );
          }

          const groups = await models.userWords.getGroups([
            "reviewedToday",
            "readyToTest",
          ]);
          readyToTest = groups.readyToTest;

          models.flashcardSession.set(
            "currentTestDeck",
            specificWords.concat(
              _.shuffle(
                _.first(
                  readyToTest.filter(
                    (word) => !_.contains(specificWordIDs, word.id)
                  ),
                  8 - specificWords.length
                )
              )
            )
          );

          models.flashcardSession.set(
            "currentDeckSize",
            models.flashcardSession.get("currentTestDeck").length
          );
          splitTest.trackEventWithProperties("startFlashcards", {
            numberOfCards: models.flashcardSession.get("currentDeckSize"),
            from: "specificWords",
          });

          appRouter.navigate("/flashcards", { replace: true });
          delete options.userWordIDs;

          displayNext();
        } catch (error) {
          console.error("couldn't find word", error);
          appRouter.navigate("/learn", {
            trigger: true,
            replace: true,
          });
          delete options.userWordIDs;
        }
        return;
      }

      if (options.chosenBookID) {
        startTest(numberOfCards, options.chosenBookID)();
        element.find(".flashcardsContainer").css("opacity", 1);
        return;
      } else {
        const groups = await models.userWords.getGroups([
          "reviewedToday",
          "readyToTest",
        ]);
        readyToTest = groups.readyToTest;

        // Start flashcard session
        startTest(Math.min(numberOfCards, readyToTest.length), undefined)();
        element.find(".flashcardsContainer").css("opacity", 1);
        return;
      }
    } else {
      renderFlashcards();

      cardCount
        .text(
          models.flashcardSession.get("currentTestDeck").length +
            " / " +
            models.flashcardSession.get("currentDeckSize") +
            " words left"
        )
        .show();

      exitTestButton.show();

      wordCardText.removeClass("shrinkText1 shrinkText2 shrinkText3");
      translationText.removeClass("shrinkText1 shrinkText2 shrinkText3");

      const currentWord = models.flashcardSession.get("currentWord");

      if (currentWord.get("note")) {
        showNoteButton.show();
        showNoteButton.click(() => {
          noteElement.find(".noteText").html(currentWord.get("note"));
          noteElement.fadeIn();
          showNoteButton.hide();
        });
      } else {
        showNoteButton.hide();
      }

      if (
        models.user.getFlashcardMode() !== "passive" &&
        currentWord.has("lastRecallEase") &&
        currentWord.get("lastRecallEase") >= 1 &&
        !currentWord.get("passiveOverride")
      ) {
        guessForeignWord = true;
      } else {
        guessForeignWord = false;
        originalWordVisible = true;
      }

      if (currentWord.has("_id")) {
        contextElement.text("Loading context...");
        contextContainer.show();

        currentWord.fetch({
          success: function () {
            updateContexts();
          },
        });
      }

      const lastSeen = currentWord.lastSeen();
      if (lastSeen) {
        let date = await currentDate.getSnapped(models.user.get("updateHour"));
        date = new Date(date.getTime() + 1000);
        const days = Math.round(
          (date.getTime() - lastSeen.getTime()) / spacedRepetition.DAY
        );
        if (days < 1) {
          categoryElement
            .text("Last seen today")
            .attr("data-category", "justStarted");
        } else if (days === 1) {
          categoryElement
            .text("Last seen yesterday")
            .attr("data-category", "justStarted");
        } else if (days < 7) {
          categoryElement
            .text("Last seen " + days + " days ago")
            .attr("data-category", "gettingThere");
        } else {
          categoryElement
            .text("Last seen " + days + " days ago")
            .attr("data-category", "mastered");
        }
      } else {
        categoryElement.text("New").attr("data-category", "notStarted");
      }

      if (guessForeignWord) {
        if (typingMode) {
          wordCardInput.val("").show().removeAttr("readonly");
          wordCardInputToolbar.show();
          setTimeout(() => {
            wordCardInput.focus();
          }, 10);
          wordCardText.hide();
          wordCard.removeClass("clickable");

          feedbackElement
            .text(
              "Type the " +
                languageMap.map[models.user.get("currentLearningLanguage")]
                  .english +
                " word in the box above"
            )
            .show();
        } else {
          wordCardInput.hide();
          wordCardInputToolbar.hide();
          wordCardText.show().html("?");
          wordCard.addClass("clickable");
        }
        wordCardAudio.hide();
        translationText.text(
          [
            currentWord.get("translation"),
            ...currentWord.get("alternativeTranslations"),
          ].join(" / ")
        );
        translationCard.removeClass("clickable");
        typingModeLabel.show();
      } else {
        wordCardAudio.show();
        wordCardInput.hide();
        wordCardInputToolbar.hide();
        revealWord();
        wordCard.removeClass("clickable");
        translationText.html("?");
        translationCard.addClass("clickable");
        typingModeLabel.hide();
      }

      if (!guessForeignWord || !typingMode) {
        feedbackElement
          .text(
            "Try guessing first, then click the question mark to reveal the answer"
          )
          .show();
      }

      wordCard.css("display", "inline-block");
      translationCard.css("display", "inline-block");
      buttonsElement.hide();
      deleteButton.hide();

      element.find(".flashcardsContainer").css("opacity", 1);
      shrinkToFit(translationText, translationCard);
    }
  };

  const cycleContext = (forward) => {
    if (!models.flashcardSession) {
      return;
    }

    const length = models.flashcardSession
      .get("currentWord")
      .get("contexts").length;
    currentContextIndex =
      (currentContextIndex + length + (forward ? 1 : -1)) % length;

    setContext(currentContext());
    if (guessForeignWord && !buttonsElement.is(":visible")) {
      const strongWord = contextElement.find("strong");
      strongWord.addClass("hidden").text(
        models.flashcardSession
          .get("currentWord")
          .get("word")
          .split("")
          .map(() => "_")
          .join("")
      );
    }
  };

  const currentContext = () => {
    const currentWord = models.flashcardSession.get("currentWord");
    if (
      currentWord &&
      currentWord.get("contexts") &&
      currentWord.get("contexts").length > 0
    ) {
      const contexts = currentWord.get("contexts");
      if (currentContextIndex === null) {
        currentContextIndex = Math.floor(Math.random() * contexts.length);
      } else {
        currentContextIndex = currentContextIndex % contexts.length;
      }

      const context = contexts[currentContextIndex];

      // this should fix symptom of a bunch of error reports
      // TODO: remove after the cause is fixed:
      //       https://trello.com/c/AS9TPum9/211-where-do-the-contexts-null-come-from
      if (!context) {
        return null;
      }

      let text = context.text;

      if (!text) {
        return null;
      }

      if (text.length < 2000) {
        if (!/[A-Z]/.test(text.substring(0, 2))) {
          // cspell:disable-next-line
          text = "&hellip;" + text;
        }
        if (!/\.|\?|!/.test(text.substring(text.length - 2, text.length))) {
          // cspell:disable-next-line
          text += "&hellip;";
        }
      } else {
        console.error("stupidly long context");
        return null;
      }

      const match = new RegExp(
        "(.*\\W)(" + regexpEscape(currentWord.get("word")) + ")(\\W.*)",
        "i"
      ).exec(" " + text + " ");

      if (match) {
        const match1 = match[1].substring(1);
        const match3 = match[3].substring(0, match[3].length - 1);
        const spannified = spannify(match1, {
          XRegExp: XRegExp,
        });
        let position = spannified.totalSpans + 1;

        text = spannified.html;
        text += "<strong>" + match[2] + "</strong>";

        position++;

        text += spannify(match3, {
          XRegExp: XRegExp,
          startPosition: position,
        }).html;
      }

      if (currentWord.has("youTubeID")) {
        text +=
          '<div id=youTubeLinkContainer><a id=youTubeLink target="_blank" ' +
          'href="http://www.youtube.com/v/' +
          currentWord.get("youTubeID") +
          "?start=" +
          currentWord.get("audioStart") +
          "&end=" +
          currentWord.get("audioEnd") +
          "&autoplay=1" +
          '&version=3">View on YouTube</a></div>';
      }

      return {
        text: text,
        bookID: context.bookID,
        URL: context.URL,
      };
    } else {
      return null;
    }
  };

  const showRecallButtons = () => {
    const currentWord = models.flashcardSession.get("currentWord");
    if (
      (!currentWord.get("recallAttempts") ||
        currentWord.get("recallAttempts") === 0) &&
      !currentWord.get("verified")
    ) {
      hintElement.show();
    }

    editElement.show();
    feedbackElement.hide();

    // show context
    const context = currentContext();
    if (context) {
      setContext(context);
      contextElement.removeClass("clickable");
      contextContainer.show();
    }

    buttonsElement.fadeIn();
    deleteButton.fadeIn();
  };

  const logWordPracticed = () => {
    readlangClient.request(
      "POST",
      "/api/userLearningLog/practiced",
      {
        wordsPracticed: 1,
        language: models.user.get("currentLearningLanguage"),
        timezoneOffset: dateUtils.getTimezoneOffset(),
      },
      async () => {
        if (await models.user.hasNewStreakFeature()) {
          models.streak.fetch();
        }
      }
    );
  };

  /** @returns {boolean} true if navigating away to session complete page */
  const showSessionCompleteIfAppropriate = () => {
    if (models.flashcardSession.inProgress()) {
      return false;
    }

    appRouter.navigate("/learn?sessionComplete=true", { trigger: true });
    return true;
  };

  var reportRecallEase = async function () {
    const ease = parseInt($(this).attr("data-score"), 10);

    soundEffect.play(ease >= 3 ? "correct" : "incorrect");

    suppressUpdates = true;
    const lengthBefore = models.flashcardSession.get("currentTestDeck").length;
    await models.flashcardSession.reportRecallEase(ease);
    const lengthAfter = models.flashcardSession.get("currentTestDeck").length;
    if (lengthAfter < lengthBefore) {
      logWordPracticed();
    }
    suppressUpdates = false;

    if (showSessionCompleteIfAppropriate()) {
      return;
    }

    displayNext();

    splitTest.trackEventWithProperties("flashcardRecall", {
      "Flashcard Mode": models.user.getFlashcardMode(),
    });
    walkthrough.setAchievement("flashcards", true);
  };

  var reportRecallEase2 = (ease) => {
    soundEffect.play(ease >= 3 ? "correct" : "incorrect");

    // show context
    const context = currentContext();
    if (context) {
      setContext(context);
      contextElement.removeClass("clickable");
      contextContainer.show();
    }

    suppressUpdates = true;
    const lengthBefore = models.flashcardSession.get("currentTestDeck").length;
    models.flashcardSession.reportRecallEase(ease, true);
    const lengthAfter = models.flashcardSession.get("currentTestDeck").length;
    if (lengthAfter < lengthBefore) {
      logWordPracticed();
    }
    suppressUpdates = false;

    revealWord();

    feedbackTick.css({
      position: "absolute",
      right: "13px",
      top: "13px",
    });

    const answerExists = wordCardInput.val().trim().length > 0;

    const feedbackCheckImage = "/content/feedback-check.svg";
    const feedbackCrossImage = "/content/feedback-cross.svg";

    if (ease > 4) {
      element.find("#feedback").text("Perfect!").show();
      feedbackTick
        .attr("src", feedbackCheckImage)
        .removeClass("negative")
        .show();
      wordCardInput.hide();
      wordCardInputToolbar.hide();
    } else if (ease > 3) {
      element.find("#feedback").text("Very close!").show();
      feedbackTick.attr("src", feedbackCrossImage).addClass("negative").show();
      if (answerExists) {
        addAlternativeWord.show();
      }
      wordCardInput.attr("readonly", "readonly");
      wordCardInputToolbar.hide();
    } else {
      element
        .find("#feedback")
        .text("Not quite, better luck next time.")
        .show();
      feedbackTick.attr("src", feedbackCrossImage).addClass("negative").show();
      if (answerExists) {
        addAlternativeWord.show();
      }
      wordCardInput.attr("readonly", "readonly");
      wordCardInputToolbar.hide();
    }

    splitTest.trackEventWithProperties("flashcardRecall", {
      "Flashcard Mode": models.user.getFlashcardMode(),
    });
    walkthrough.setAchievement("flashcards", true);
  };

  const languageList = [];
  _.each(languageMap.map, (info, code) => {
    languageList.push({
      code: code,
      info: info,
    });
  });

  $(document).ready(() => {
    $("title").text("Learn - Readlang");
    renderFlashcards();
    displayNext();
  });
};

export const close = () => {
  $("body").removeAttr("data-clickMode");
  $("body").removeClass("glossStyle");
  subviewManager?.removeSubviews();
  subviewManager = undefined;
  element.show();
};

export const showHeader = true;
export const currentTestDeck = () =>
  models.flashcardSession.get("currentTestDeck");
